import { FC, useState, useEffect } from 'react';
import { Drawer, Button, ButtonSize, useTranslation, ButtonStyles, ButtonWidth } from '@nextgen-web-framework/all';
import { useSelector } from 'react-redux';
import type { AppState } from '@nextgen-web-framework/core';
import HtmlContent from '../../../common/HtmlContent/HtmlContent';
import styles from './TnCDrawer.module.scss';
import { TnCDrawerProps } from './types/propType';

const TnCDrawer: FC<TnCDrawerProps> = ({ showDrawer, onAcceptTnC }): React.JSX.Element => {
  const t = useTranslation();
  const { subscriptionsCmsData } = useSelector((state: AppState) => state.commerceSubscription);
  const configs = ConfigService.getConfigs();
  const sopEnhancedUx = configs.NEXT_SOP_ENHANCED_UX_ENABLED;
  const [termsAndConditions, setTermsAndConditions] = useState<string>('');

  useEffect(() => {
    if (subscriptionsCmsData.length) {
      setTermsAndConditions(subscriptionsCmsData[0].terms_and_conditions);
    }
  }, [subscriptionsCmsData]);

  const closeDrawer = () => {
    showDrawer(false);
  };

  return (
    <Drawer
      header={<div>{t('subscription.TermsAndConditions.tncDrawerTitle')}</div>}
      bottomGap={0}
      footer={
        <div className={styles['tnc-footer-drawer']}>
          {!sopEnhancedUx && (
            <Button
              data-testid="cancelBtn-testid"
              title={t('subscription.subscriptionSelection.cancelButtonText')}
              size={ButtonSize.MEDIUM}
              buttonStyle={ButtonStyles.OUTLINE}
              buttonWidth={ButtonWidth.FULL_WIDTH}
              onClick={closeDrawer}
            />
          )}
          <Button
            data-testid="back-testid"
            title={
              sopEnhancedUx
                ? t('subscription.TermsAndConditions.acceptTermsAndConditions')
                : t('subscription.TermsAndConditions.acceptTncButtonText')
            }
            size={ButtonSize.MEDIUM}
            buttonStyle={ButtonStyles.SOLID}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            onClick={() => {
              onAcceptTnC(true);
              closeDrawer();
            }}
          />
        </div>
      }
      closeIcon={true}
      closeOnBackdropClick={true}
      onClose={closeDrawer}
      useReactPortal={true}
      portalContainerId="react-portal-drawer"
    >
      <div className={styles['tnc-content']}>
        <HtmlContent content={termsAndConditions} />
      </div>
    </Drawer>
  );
};

export default TnCDrawer;
